import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  UseDisclosureReturn,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

type Props = UseDisclosureReturn & {
  title: string;
  body: string;
  buttonText: string;
  to: string;
};

export const ForceNavModal = ({ title, body, buttonText, to, ...disclosure }: Props) => {
  const nav = useNavigate();

  return (
    <Modal
      {...disclosure} // Force them to go back
      onClose={() => {}}
      size="lg"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{body}</ModalBody>
        <ModalFooter>
          <Button onClick={() => nav(to)} colorScheme="primary">
            {buttonText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
